import productionConfigs from './production'

const betaConfigs = {
  ...productionConfigs,
  ntm_script:
    '!function(t,n){n=n||"ntm";window["ntm_"+t]=n,window[n]=window[n]||[],window[n].push({"ntm.start":+new Date});t=document.getElementsByTagName("script")[0],n=document.createElement("script");n.async=!0,n.src="https://ntm.pstatic.net/scripts/ntm_9734f1409056_stage.js",t.parentNode.insertBefore(n,t)}("9734f1409056","ntm");',
} as const

export default betaConfigs
